'use client';

import { type PropsWithChildren, useEffect, useMemo } from 'react';

export type Performer = (() => boolean | void) | undefined | null;

export const useRunPerformersQueue = (performers: readonly Performer[]) => {
	const doneSet = useMemo(() => new WeakSet<() => boolean | void>(), []);

	useEffect(() => {
		for (const handler of performers) {
			if (!handler) {
				return;
			}

			if (handler && !doneSet.has(handler)) {
				doneSet.add(handler);

				if (handler()) {
					return;
				}
			}
		}
	}, [doneSet, performers]);
};

export const createPerformer = (hooks: readonly (() => Performer)[]) => {
	const Performer = ({ children }: PropsWithChildren) => {
		useRunPerformersQueue(hooks.map((hook) => hook()));

		return children;
	};

	return Performer;
};
